import { Accordion as MuiAccordion } from '@mui/material';
import * as React from 'react';
import { TAccordion } from './Accordion.types';
import './Accordion.styles.scss';

export const Accordion: TAccordion = (props) => {
  return <MuiAccordion className="accordion" {...props} />;
};
